module.exports = "/images/id-step4en.png?1459ecd49d20b66dbd4acd93cbea9a72";